import React from "react";
import Row from "react-bootstrap/Row";
import { Heading ,T} from "../components/helpful";
import Dropdown from "react-bootstrap/Dropdown";

/* The class `NewRoomStatus` in JavaScript defines a component that displays hotel room status and
factsheets with custom dropdown menu options. 
@author lionel ghogue ngondeke <lionelladrog@gmail.com>
*/
export default class NewRoomStatus extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageTitle: <T value={"New Room Status"} />,
      hotelImg: 0,
      desc: "( 6 unread notifications )",
    };

    this.factsheets = [
      {
        category: "Hotel Room Status",
        content: [
          {
            id: 1,
            title: "Dinarobin Beachcomber - Hotel Factsheet - 22-23",
            date: "3 hours ago",
          },
          {
            id: 2,
            title: "Paradis Beachcomber - Hotel Factsheet - 22-23",
            date: "5 hours ago",
          },
          {
            id: 3,
            title: "Victoria Beachcomber - Hotel Factsheet - 22-23",
            date: "5 hours ago",
          },
        ],
      },
      {
        category: "Meal Plan Factsheets",
        content: [
          {
            id: 1,
            title: "Dinarobin Beachcomber - Escape Package - 22-23",
            date: "A day ago",
          },
        ],
      },
      {
        category: "Thematical Factsheets",
        content: [
          {
            id: 1,
            title: "Mauritius - Diving - Usd - 22-23",
            date: "2 weeks ago",
          },
        ],
      },
    ];

    this.customMenu = this.customMenu.bind(this);
  }
  customMenu() {
    return (
      <>
        <Dropdown className="custom-dropdown-menu">
          <Dropdown.Toggle variant="" id="" className="">
            <i className="bi bi-three-dots"></i>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item href="#/action-1">Save</Dropdown.Item>

            <Dropdown.Item href="#/action-3">Delete</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </>
    );
  }

  subHeading = () => {
    return <>{this.state.desc}</>;
  }
  render() {
    return (
      <div>
        <div className="">
          <div className="sticky-top">
            <Heading heading={this.state.pageTitle} Desc={this.subHeading} />
          </div>
          <Row className="main-content">
            {this.factsheets.map((list, index) => {
              return (
                <>
              <h5 className="unordered-list-title">{list.category}:</h5>
                  <ul className="unordered-list">
                    {list.content.map((item) => {
                      return (
                        <li key={item.id}>
                          <span>{item.title}</span>
                          {this.customMenu()}
                          <p className="">{item.date}</p>
                        </li>
                      );
                    })}
                  </ul>
                </>
              );
            })}
          </Row>
        </div>
      </div>
    );
  }
}
